import React from 'react';
import _ from 'lodash';

import SettingsGeneralForm from '../forms/SettingsGeneralForm';
import CompanyStore from '../stores/CompanyStore';
import BillingDetailsStore from '../stores/BillingDetailsStore';
import CompanyActions from '../actions/CompanyActions';
import BillingDetailsActions from '../actions/BillingDetailsActions';
import LoadingView from '../components/LoadingView';
import {UploadedFile} from '../forms/FileUpload.js';

import connectToStores from 'alt/utils/connectToStores';

@connectToStores
class SettingsGeneral extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedLogoSrc: "",
            settingsSaved: false,
            isLoading: false
        };

        CompanyStore.getCompany();
        BillingDetailsStore.getBillingDetails();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.companyStore.saveError && Object.keys(nextProps.companyStore.saveError).length) {
            this.setState({isLoading: false});
        }
        if (nextProps.companyStore.settingsSaved !== this.state.settingsSaved) {
            //Setting timeout to give spinner a chance to show properly
            setTimeout(x => {this.setState({settingsSaved: nextProps.companyStore.settingsSaved, isLoading: false})}, 250);
        }
    }

    static getPropsFromStores() {
        return {
            companyStore: CompanyStore.getState(),
            billingDetailsStore: BillingDetailsStore.getState()
        };
    }

    static getStores() {
        return [CompanyStore, BillingDetailsStore];
    }

    splitFormData(data) {
        const { vat_number, registry_id, billing_email, billing_address: address, billing_city: city, billing_country: country,
            billing_lat: lat, billing_lng: lng, billing_street: street, billing_zip: zip } = data;
        const billingDetails = {
            vat_number, registry_id, billing_email, address, city, country, lat, lng, street, zip
        };
        const company = _.omit(data, [
            'vat_number', 'registry_id', 'billing_email', 'billing_address', 'billing_city', 'billing_country',
            'billing_lat', 'billing_lng', 'billing_street', 'billing_zip'
        ]);
        return {company, billingDetails};

    }

    saveSettings() {
        const errors = this.refs.detailsForm.validate(true).errors;
        if (Object.keys(errors).length > 0) {
            CompanyActions.mergeErrorsIntoState(errors);
        } else {
            const {company, billingDetails} = this.splitFormData(this.refs.detailsForm.getValue());
            if (company && billingDetails) {
                this.setState({isLoading: true});
                CompanyActions.mergeErrorsIntoState();
                CompanyActions.updateCompany(company);
                BillingDetailsActions.updateBillingDetails(billingDetails);
            }
        }
    }

    importantAddressParts(obj) {
        const parts = [];
        [obj.street, obj.city, obj.country].filter(part => {
            if (part && part !== "" && part.length > 0) {
                parts.push(part);
            }
        });
        return parts;
    }

    prepareData(company) {
        const companyData = company;
        const billingDetails = this.props.billingDetailsStore.billingDetails;
        if (company.logo) {
            companyData.logo = new UploadedFile(
                company.logo.fileName, company.logo.dataUri, company.logo.mimeType, company.logo.size
            );
        }

        companyData.address = company.formatted_address || this.importantAddressParts(company).join(', ');

        if (Object.keys(billingDetails).length) {
            companyData.vat_number = billingDetails.vat_number;
            companyData.billing_email = billingDetails.billing_email;
            companyData.registry_id = billingDetails.registry_id;
            companyData.billing_address = billingDetails.formatted_address || this.importantAddressParts(billingDetails).join(', ');
            companyData.billing_country = billingDetails.country;
            companyData.billing_city = billingDetails.city;
            companyData.billing_street = billingDetails.street;
            companyData.billing_zip = billingDetails.zip;
            companyData.billing_lat = billingDetails.lat;
            companyData.billing_lng = billingDetails.lng;
        }

        return companyData;
    }

    getSaveButton(company) {
        let button = <button onClick={this.saveSettings.bind(this, company.id)} className="btn btn-small btn-green">Save settings</button>;
        if (this.state.isLoading) {
            button = <button className="btn btn-small btn-green"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></button>;
        }
        return button;
    }

    render () {
        const company = this.props.companyStore.company;
        const settingsSaved = this.state.settingsSaved;

        if (!this.props.companyStore.companyDataReceived || !this.props.billingDetailsStore.billingDetailsReceived) {
            return <LoadingView />;
        }

        return (
            <div className={"settings-general" + (this.props.isActive ? " active" : "")}>
                <SettingsGeneralForm ref="detailsForm" initialFormData={this.prepareData(company)} errors={this.props.companyStore.saveError} />
                        <div className="tab-section">
                    {this.getSaveButton(company)}
                    <p className={"data-info " + (settingsSaved ? "saved" : "")}>Settings saved!</p>
                </div>
            </div>
        );
    }
}

export default SettingsGeneral;



/** WEBPACK FOOTER **
 ** ./app/src/components/SettingsGeneral.js
 **/